import axios from "axios";
import qs from 'qs'
//将所有的主机名和端口 一起设置
// axios.defaults.baseURL = "crmapi.kidcastle.org";
import Urls from "../../urlLink";
import {isGraySchoolEnabled} from "@/bootstrap/graySchoolRouting";
const root = Urls.crmApiUrl; //域名
//首页数据请求
const url = {
  changeXzToKzApi: root + "/Client/changeXzToKzApi",
  changeStafferApi: root + "/Client/changeStafferApi",
  getCommodeApi: root + "/Public/getCommodeApi",
  getMarketer: root + "/Public/getMarketerApi",
  schoolClientRerport: root + "/Report/schoolClientRerport",
  schoolClientRerportExport: root + "/Report/schoolClientRerport/Export",
  marketerClientReport: root + "/Report/marketerClientReport",
  marketerClientReportExport: root + "/Report/marketerClientReport/Export",
  channelClientReport: root + "/Report/channelClientReport",
  channelClientReportExport: root + "/Report/channelClientReport/Export",
  schoolMothReport: root + "/Report/schoolMothReport",
  schoolMothReportExport: root + "/Report/schoolMothReport/Export",
  marketerMothRrport: root + "/Report/marketerMothRrport",
  marketerMothRrportExport: root + "/Report/marketerMothRrport/Export",
  channelConsult: root + "/Report/channelConsult",
  channelConsultExport: root + "/Report/channelConsult/Export",
  getSource: root + "/Public/getSourceApi",
  getChannel: root + "/Public/getChannelApi",
  detailsByChannel: root + "/Report/detailsByChannel",
  detailsByChannelExport: root + "/Report/detailsByChannel/Export",
  gainsByChannel: root + "/Report/gainsByChannel",
  getClientHighestReport: root + "/Report/getClientHighestReport",
  getClientRecruitReport: root + "/Report/getClientRecruitReport",
  getClientRecruitReportExport: root + "/Report/getClientRecruitReport/Export",
  getReportClientListApi: root + "/Report/getReportClientListApi",
  courseTypeApi: root + "/Public/courseTypeApi",
  trackDetailByLinkType: root + "/Report/trackDetailByLinkType",
  trackDetailByLinkTypeExport: root + "/Report/trackDetailByLinkType/Export",
  activityPositiveReport: root + "/Report/activityPositiveReport",
  activityPositiveReportExport: root + "/Report/activityPositiveReport/Export",
  activityClientList: root + "/Report/activityClientList",
  activityClientListExport: root + "/Report/activityClientList/Export",
  courseRecruitCount: root + "/Report/courseRecruitCount",
  courseRecruitCountExport: root + "/Report/courseRecruitCount/Export",
  // addClient:root+"/Client/addClientAction",

  getPerformanceYear: root + "/Report/getPerformanceYear", // 报表->招生业绩年度汇总表->wgh
  getPerformanceYearExport: root + "/Report/getPerformanceYear/Export", // 报表->招生业绩年度汇总表->wgh
  getPerformanceMonth: root + "/Report/getPerformanceMonth", // 报表->招生业绩月度汇总表->wgh
  getPerformanceMonthExport: root + "/Report/getPerformanceMonth/Export", // 报表->招生业绩月度汇总表->wgh
  getPerformanceWeek: root + "/Report/getPerformanceWeek", // 报表->招生业绩周度汇总表->wgh
  getPerformanceWeekExport: root + "/Report/getPerformanceWeek/Export", // 报表->招生业绩周度汇总表->wgh
  getInvite: root + "/Report/getInvite", // 报表->招生邀约状况统计表->qyh
  getInviteExport: root + "/Report/getInvite/Export", // 报表->招生邀约状况统计表->qyh
  getCenterTrackWeek: root + "/Report/getCenterTrackWeek", // 报表->招生追踪周度统计表->zjb
  getCenterTrackWeekExport: root + "/Report/getCenterTrackWeek/Export", // 报表->招生追踪周度统计表->zjb
  getCenterTrackMonth: root + "/Report/getCenterTrackMonth", // 报表->招生邀约状况统计表->qyh
  getCenterTrackMonthExport: root + "/Report/getCenterTrackMonth/Export", // 报表->招生邀约状况统计表->qyh
  getInviteSelf: root + "/Report/getInviteSelf", // 报表->招生主动到访统计表->qyh
  getInviteSelfExport: root + "/Report/getInviteSelf/Export", // 报表->招生主动到访统计表->qyh
  getRegisterInfo: root + "/Report/getRegisterInfo", // 监管分析报表->招生对照明细表->xzl
  getRegisterInfoExport: root + "/Report/getRegisterInfo/Export", // 监管分析报表->招生对照明细表->xzl
  getTeachersAdmissions: root + "/Report/getTeachersAdmissions",
  getTeachersAdmissionsExport: root + "/Report/getTeachersAdmissions/Export",
};
const storeanalysisreport = {
  changeXzToKzApi(params) {
    return axios.post(url.changeXzToKzApi, qs.stringify(params));
  },
  changeStafferApi(params) {
    return axios.post(url.changeStafferApi, qs.stringify(params));
  },
  getCommodeApi(params) {
    return axios.get(url.getCommodeApi, { params });
  },
  getMarketer(params) {
    return axios.get(url.getMarketer, { params });
  },
  trackDetailByLinkType(params) {
    return axios.get(url.trackDetailByLinkType, { params });
  },
  trackDetailByLinkType1() {
    return isGraySchoolEnabled() ? url.trackDetailByLinkTypeExport : url.trackDetailByLinkType;
  },
  getTeachersAdmissions(params) {
    return axios.get(url.getTeachersAdmissions, { params });
  },
  getTeachersAdmissions1() {
    return isGraySchoolEnabled() ? url.getTeachersAdmissionsExport : url.getTeachersAdmissions;
  },

  getPerformanceYear(params) {
    return axios.get(url.getPerformanceYear, { params });
  },
  getPerformanceYear1() {
    return isGraySchoolEnabled() ? url.getPerformanceYearExport : url.getPerformanceYear;
  },
  getPerformanceMonth(params) {
    return axios.get(url.getPerformanceMonth, { params });
  },
  getPerformanceMonth1() {
    return isGraySchoolEnabled() ? url.getPerformanceMonthExport : url.getPerformanceMonth;
  },
  getPerformanceWeek(params) {
    return axios.get(url.getPerformanceWeek, { params });
  },
  getPerformanceWeek1() {
    return isGraySchoolEnabled() ? url.getPerformanceWeekExport : url.getPerformanceWeek;
  },
  getInvite(params) {
    return axios.get(url.getInvite, { params });
  },
  getInvite1() {
    return isGraySchoolEnabled() ? url.getInviteExport : url.getInvite;
  },
  getCenterTrackWeek(params) {
    return axios.get(url.getCenterTrackWeek, { params });
  },
  getCenterTrackWeek1() {
    return isGraySchoolEnabled() ? url.getCenterTrackWeekExport : url.getCenterTrackWeek;
  },
  getCenterTrackMonth(params) {
    return axios.get(url.getCenterTrackMonth, { params });
  },
  getCenterTrackMonth1() {
    return isGraySchoolEnabled() ? url.getCenterTrackMonthExport : url.getCenterTrackMonth;
  },
  getInviteSelf(params) {
    return axios.get(url.getInviteSelf, { params });
  },
  getInviteSelf1() {
    return isGraySchoolEnabled() ? url.getInviteSelfExport : url.getInviteSelf;
  },
  getRegisterInfo(params) {
    return axios.get(url.getRegisterInfo, { params });
  },
  getRegisterInfo1() {
    return isGraySchoolEnabled() ? url.getRegisterInfoExport : url.getRegisterInfo;
  },

  activityPositiveReport(params) {
    return axios.get(url.activityPositiveReport, { params });
  },
  activityPositiveReport1() {
    return isGraySchoolEnabled() ? url.activityPositiveReportExport : url.activityPositiveReport;
  },
  activityClientList(params) {
    return axios.get(url.activityClientList, { params });
  },
  activityClientList1() {
    return isGraySchoolEnabled() ? url.activityClientListExport : url.activityClientList;
  },
  courseRecruitCount(params) {
    return axios.get(url.courseRecruitCount, { params });
  },
  courseRecruitCount1() {
    return isGraySchoolEnabled() ? url.courseRecruitCountExport :url.courseRecruitCount;
  },
  //Crn报表->获取校园追踪大表-lujing
  getClientHighestReport(params) {
    return axios.get(url.getClientHighestReport, { params });
  },
  getClientHighestReport1() {
    return url.getClientHighestReport;
  },
  getClientRecruitReport(params) {
    return axios.get(url.getClientRecruitReport, { params });
  },
  getClientRecruitReport1() {
    return isGraySchoolEnabled() ? url.getClientRecruitReportExport : url.getClientRecruitReport;
  },
  //CRM报表->追踪大表->根据字段获招生详情-lujing
  getReportClientListApi(params) {
    return axios.get(url.getReportClientListApi, { params });
  },
  //Crm报表->渠道招生明细表
  detailsByChannel(params) {
    return axios.get(url.detailsByChannel, { params });
  },
  detailsByChannel1() {
    return isGraySchoolEnabled() ? url.detailsByChannelExport : url.detailsByChannel;
  },
  //Crm报表->渠道业绩报表
  gainsByChannel(params) {
    return axios.get(url.gainsByChannel, { params });
  },
  gainsByChannel1() {
    return url.gainsByChannel;
  },
  //Crm报表->学校招生咨询报表
  schoolClientRerport(params) {
    return axios.get(url.schoolClientRerport, { params });
  },
  // 招生个人业绩统计表
  marketerClientReport(params) {
    return axios.get(url.marketerClientReport, { params });
  },
  //渠道业绩统计表
  channelClientReport(params) {
    return axios.get(url.channelClientReport, { params });
  },
  //CRM报表->校招生月度统计报表
  schoolMothReport(params) {
    return axios.get(url.schoolMothReport, { params });
  },
  //CRM报表->个人招生月度业绩统计报表
  marketerMothRrport(params) {
    return axios.get(url.marketerMothRrport, { params });
  },
  // CRM报表->渠道咨询报表
  channelConsult(params) {
    return axios.get(url.channelConsult, { params });
  },
  // 获取招生渠道类型
  getSource(params) {
    return axios.get(url.getSource, {
      params,
    });
  },
  // 获取招生渠道明细
  getChannel(params) {
    return axios.get(url.getChannel, {
      params,
    });
  },
  // 获取班组下拉
  courseTypeApi(params) {
    return axios.get(url.courseTypeApi, {
      params,
    });
  },
  schoolClientRerport1() {
    return isGraySchoolEnabled() ? url.schoolClientRerportExport : url.schoolClientRerport;
  },
  marketerClientReport1() {
    return isGraySchoolEnabled() ? url.marketerClientReportExport : url.marketerClientReport;
  },
  channelClientReport1() {
    return isGraySchoolEnabled() ? url.channelClientReportExport : url.channelClientReport;
  },
  schoolMothReport1() {
    return isGraySchoolEnabled() ? url.schoolMothReportExport: url.schoolMothReport;
  },
  marketerMothRrport1() {
    return isGraySchoolEnabled() ? url.marketerMothRrportExport: url.marketerMothRrport;
  },
  channelConsult1() {
    return isGraySchoolEnabled() ? url.channelConsultExport: url.channelConsult;
  },
  // // 转为招生线索或无意向
  // changeIntentionClient(params){
  //   return axios.post(url.changeIntentionClient,qs.stringify(params))
  // },
};

export default storeanalysisreport;
